import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LinkOptionsFormComponent} from './link-options-form.component';
import {ReactiveFormsModule} from '@angular/forms';
import {TranslationsModule} from '@common/core/translations/translations.module';
import {DatetimeInputModule} from '@common/core/ui/datetime-input/datetime-input.module';
import {PermissionAwareInputContainerComponent} from '../../permission-aware-input-container/permission-aware-input-container.component';
import {PermissionAwareButtonComponent} from '../../permissions/permission-aware-button/permission-aware-button.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { UploadImageControlModule } from '@common/shared/form-controls/upload-image-control/upload-image-control.module';
import { ChipsModule } from '@common/core/ui/chips/chips.module';
import { DomainFormControlComponent } from './domain-form-control/domain-form-control.component';

@NgModule({
    declarations: [
        LinkOptionsFormComponent,
        DomainFormControlComponent,
        PermissionAwareInputContainerComponent,
        PermissionAwareButtonComponent,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        TranslationsModule,
        DatetimeInputModule,
        UploadImageControlModule,
        ChipsModule,

        MatButtonModule,
        MatIconModule,
        MatFormFieldModule,
        MatSelectModule,
    ],
    exports: [
        LinkOptionsFormComponent,
        PermissionAwareInputContainerComponent,
        PermissionAwareButtonComponent,
        DomainFormControlComponent
    ],
})
export class LinkOptionsFormModule {}
